// extracted by mini-css-extract-plugin
export default {"main":"SandboxName_main__JxraP"};